(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/pix-handler/common/helpers.js') >= 0) return;  svs.modules.push('/components/sport/pix-handler/common/helpers.js');
'use strict';

const createPixDataKey = (productId, drawNumber, systemCost, systemType, additionalCacheKey) => 
"".concat(productId, "_").concat(drawNumber, "_").concat(systemCost, "_").concat(systemType).concat(additionalCacheKey ? "_".concat(additionalCacheKey) : '');
setGlobal('svs.components.sport.pixHandler.common.helpers', {
  createPixDataKey
});

 })(window);